/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

/**
 * Simple singleton style container for holding the internationalization tables (I18N).
 */
var iaw = iaw || { };

iaw.i18n = {

	localizedStringTable:	null,
	urlLocalizationTable:	null,

	/**
	 * Normalize the Adobe locale to a standardized one. Basically converts
	 * a locale ID like ja_JP to ja-jp.
	 *
	 * @param localeID  		locale ID string to normalize
	 * @return the normalized locale ID string
	 */
	normalizeLocaleID: function(localeID) {
		return localeID ? localeID.toLowerCase().replace('_', '-') : localeID;
	},

	/**
	 * Initialize the table from a file in JSON format.
	 *
	 * @param localeID          string containing the locale to load
	 * @param continueFn        continuation function callback
	 */
	addFromLocalLocaleFile: function( localeID, continueFn ) {

		var self    = this;
		var xmlhttp = new XMLHttpRequest();

		xmlhttp.overrideMimeType('application/json');
		xmlhttp.onreadystatechange = function() {

			if ( xmlhttp.readyState === 4 && xmlhttp.responseText ) {
//				xmlhttp.status == 200 && // local file will return status code 0

				if ( xmlhttp.responseText ) {
					self.localizedStringTable = JSON.parse( xmlhttp.responseText );
				}

				// update html language tag for accessibility
				document.getElementsByTagName('html')[0]
					.setAttribute('lang', localeID.toLowerCase().replace(/_/, '-'));

				if ( continueFn ) { continueFn(); }
			}
		};
		xmlhttp.open('GET', './locale/'+localeID+'/strings.json', true);
		xmlhttp.send();
	},

	/**
	 * Add a localized string to the object's string table.
	 *
	 * @param stringID      string representing the index key into the table
	 * @param value         string value to store with associated key
	 */
	addLocalizedString: function( stringID, value ) {
		if ( stringID ) { this.localizedStringTable[stringID] = value; }
	},

	/**
	 * Retrieve a localized string to the object's string table. If the string
	 * is not present, then a standard error string is returned instead.
	 *
	 * @param stringID      string representing the index key into the table
	 * @return String value to associated with the key
	 */
	getLocalizedString: function( stringID ) {
		var locStr = this.localizedStringTable && stringID ? this.localizedStringTable[stringID] : null;
		var newStr = locStr ? locStr.replace('^n', '<br>') : '';
		return newStr;// debug ? 'NON-LOCALIZED:'+stringID : '';
	},

	/**
	 * Retrieve a localized string to the object's string table. If the string
	 * is not present, then a standard error string is returned instead.
	 *
	 * @param stringID      string representing the index key into the table
	 * @return String value to associated with the key
	 */
	getLocalizedSubstitutionString: function( stringID, subArray ) {
		var locStr = (this.localizedStringTable && stringID) ? this.localizedStringTable[stringID] : null;

		if ( locStr && subArray ) {
			for ( var index = 0; index < subArray.length; index++ ) {
				locStr = locStr.replace('^'+index, subArray[index] );
			}
		}
		else {
			locStr = '';// debug ? 'NON-LOCALIZED:'+stringID : '';
		}
		return locStr;
	},

	/**
	 * Change a document element display string to a translated string.
	 *
	 * @param elementID             document element ID
	 * @param stringID              translation key-string ID
	 * @param dontLocalize          boolean to indicate not to localize
	 */
	setDocumentElementString : function( elementID, stringID, dontLocalize ) {
		stringID = !stringID ? elementID : stringID;

		var elem = document.getElementById( elementID );

		if ( elem ) {
			elem.innerHTML = !dontLocalize ? this.getLocalizedString( stringID ) : stringID;
		}
	},

	/**
	 * Initialize the table from a file in JSON format.
	 *
	 * @param type          string containing the url type.
	 */
	addFromURLFile : function( type  ) {
		var self    = this;
		var xmlhttp = new XMLHttpRequest();

		xmlhttp.overrideMimeType('application/json');
		xmlhttp.onreadystatechange = function() {

			if ( xmlhttp.readyState === 4 && xmlhttp.responseText ) {
//				 xmlhttp.status == 200 && // local files will return status code 0
				if ( xmlhttp.responseText ) {
					try {
						self.urlLocalizationTable = JSON.parse( xmlhttp.responseText );
					}
					catch (e) {
//						window.alert('i18n table parse error: '+e.message);
						iaw.log.exception('i18n go URL table parse error: '+e.message);
					}
				}
			}
		};

		if (type === 'goURL' ) {
			xmlhttp.open('GET', './locale/'+'goURL.json', true);
		}
		xmlhttp.send();
	},

	/**
	 * Get language id for help url.
	 *
	 * @param appLang       string containing language id xx_XX from app, such like, en_US
	 * @return String value to associated with the app language.
	 */
	getLangSuffixForHelpURL : function( appLang ) {
		var helpURL =	this.urlLocalizationTable &&
						this.urlLocalizationTable.help &&
						appLang ? this.urlLocalizationTable.help[appLang] : null;

		return helpURL ? helpURL : 'en';
	},

	/**
	 * Get language id for account url.
	 *
	 * @param appLang       string containing language id xx_XX from app, such like, en_US
	 * @return String value to associated with the app language.
	 */
	getLangSuffixForAccountURL : function( appLang ) {
		var accountURL = this.urlLocalizationTable &&
						 this.urlLocalizationTable.account &&
						 appLang ? this.urlLocalizationTable.account[appLang] : null;

		return accountURL ? accountURL : 'en';
	},

	/**
	 * Get language id for mobile creations store url.
	 *
	 * @param appLang       string containing language id xx_XX from app, such like, en_US
	 * @return String value to associated with the app language.
	 */
	getLangSuffixForMobileCreationsGoURL : function( appLang ) {
		var suffix = this.urlLocalizationTable &&
					 this.urlLocalizationTable.mobilecreations &&
					 appLang ? this.urlLocalizationTable.mobilecreations[appLang] : null;

		return (suffix && suffix !== 'en') ? '_'+suffix : '';  // for enUS default is just empty
	}
};
